import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 0c6.627 0 12 5.252 12 11.731 0 6.48-5.373 11.731-12 11.731S0 18.21 0 11.732C0 5.251 5.373 0 12 0m.706 12.421h4.235v-1.38h-4.235v-5.52h-1.412v6.9z"
    }, null, -1)
  ]))]))
}
export default { render: render }